var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-0 border",attrs:{"headers":_vm.headers,"items":_vm.morbilidades,"sort-desc":[false, true],"items-per-page":10,"multi-sort":""}})}
var staticRenderFns = []

export { render, staticRenderFns }